<template>
  <div>
<b-modal
        id="modalTitular"
        title="Adicionar Titular"
        centered
        hide-footer
      >
        <div class="modalTitular">
          <h2 class="maze">Complete os dados do responsável</h2>
          <p
            class="maze mb-3"
          >Verificamos que o dependente é menor de idade. Com isso precisamos de mais algumas informações do responsável.<br>
          Complete-as abaixo:</p>
          <form>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">Nome</label>
                  <input 
                    type="text" id="email" 
                    v-model="novoTitular.name" 
                    class="form-control" 
                    placeholder="Nome"
                  />
                </div>
              </div>  
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">E-mail</label>
                  <input
                    type="text"
                    id="email"
                    v-model="novoTitular.email"
                    class="form-control"
                    placeholder="E-mail"
                  />
                </div>
              </div>  
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="email">CPF</label>
                  <input
                    type="text"
                    id="email"
                    v-model="novoTitular.cpf"
                    class="form-control"
                    v-mask="'###.###.###-##'"
                    placeholder="CPF"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="email">Aniversário</label>
                  <input
                    type="text"
                    id="email"
                    v-mask="'##/##/####'"
                    v-model="novoTitular.birth_date"
                    class="form-control"
                    placeholder="Nascimento"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="email">RG</label>
                  <input 
                    type="text" 
                    id="email" 
                    v-model="novoTitular.rg" 
                    class="form-control"
                    v-mask="'##################'"
                    placeholder="RG"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">Nome da Mãe</label>
                  <input
                    type="text"
                    id="email"
                    v-model="novoTitular.nome_mae"
                    class="form-control"
                    placeholder="Nome da mãe"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Parentesco com os dependentes</label>
                  <select
                    v-model="novoTitular.parentesco"
                    class="form-control"
                  >
                    <option value="" selected disabled>Selecione o grau de parentesco</option>
                    <option value="Pai">Pai</option>
                    <option value="Mae">Mãe</option>
                    <option value="Nenhum, sou tutelar do(s) dependente(s)">Nenhum, sou tutelar do(s) dependente(s)</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Estado Civil</label>
                  <select
                    v-model="novoTitular.estado_civil"
                    class="form-control"
                  >
                    <option value="" selected disabled>Selecione o estado civil</option>
                    <option value="Amasiado">Amasiado</option>
                    <option value="Casado">Casado</option>
                    <option value="Convivente">Convivente</option>
                    <option value="Desquitado">Desquitado</option>
                    <option value="Divorciado">Divorciado</option>
                    <option value="Separado">Separado</option>
                    <option value="Solteiro">Solteiro</option>
                    <option value="Viúvo">Viúvo</option>
                    <option value="Outros">Outros</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Gênero</label>
                  <select
                    v-model="novoTitular.genero"
                    class="form-control"
                  >
                    <option value="" selected disabled>Selecione o gênero</option>
                    <option value="Feminino">Feminino</option>
                    <option value="Masculino">Masculino</option>
                    <option value="Outros">Outros</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="btn-cadastro">
              <button type="button" @click="criarTitular" class="btn_1 mb-5 mt-2 medium pull-right btn-color flex align-items-center justify-content-center">
                Efetivar Cadastro
              </button>
            </div>
          </form>
        </div>
      </b-modal>
	<loading :active.sync="isLoading" color="#64B9B0"></loading>
	<div class="content-wrapper">
	  <div class="container-fluid">
		<!-- Breadcrumbs-->
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
				<router-link to="/adm/titulares">Dependentes</router-link>
				</li>
				<li class="breadcrumb-item active">Detalhes Dependente</li>
			</ol>


			<div class="box_general padding_bottom">
				<div class="header_box version_2">
				<h2>
					<i class="fa fa-info-circle"></i>Informações do Dependente
				</h2>
			</div>

			<!-- Primeira Linha -->
			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>Nome do Dependente</label>
						<input
							type="text"
							class="form-control"
							v-model="dependente.name"
						/>
					</div>
				</div>
					
				<div class="col-md-4">
					<div class="form-group">
					<label>CPF</label>
					<input
						type="text"
						class="form-control"
						v-model="dependente.cpf"
					/>
					</div>
				</div>

          <div class="col-md-4">
						<div class="form-group">
							<label>RG</label>
							<input
							type="text"
							class="form-control"
							v-model="dependente.rg"
							/>
						</div>
					</div>
				</div>

        <!-- Segunda Linha -->
		<div class="row">
          <div class="col-md-8">
				<div class="form-group">
					<label>Parentesco</label>
					<input
					type="text"
					class="form-control"
					v-model="dependente.parentesco"
					/>
				</div>
			</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>E-mail do Dependente</label>
							<input
							type="text"
							class="form-control"
							v-model="dependente.email"
							/>
						</div>
					</div>
				</div>

        <!-- Terceira Linha -->
				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label>Data de Nascimento</label>
							<input
								type="date"
								class="form-control"
								v-model="dependente.birth_date"
							/>
						</div>
					</div>

          <div class="col-md-4">
					  <div class="form-group">
							<label>Nome da Mãe</label>
							<input
							type="text"
							class="form-control"
							v-model="dependente.nome_mae"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Nome do Pai</label>
							<input
							type="text"
							class="form-control"
							v-model="dependente.nome_pai"
							/>
						</div>
          			</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Estado Civil</label>
							<input
								type="text"
								class="form-control"
							v-model="dependente.estado_civil"
							/>
						</div>
          			</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Gênero</label>
							<input
								type="text"
								class="form-control"
								v-model="dependente.genero"
							/>
						</div>
          			</div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<p class="pull-right">
							<button class="btn_1 medium" @click="edita_dependente()">Editar Dependente</button>
						</p>
					</div>
				</div>

			</div>


      <!-- Informações do Plano -->
      <div class="box_general padding_bottom">
				<div class="header_box version_2">
				<h2>
					<i class="fa fa-info-circle"></i>Informações do Plano
				</h2>
			</div>
				<!-- Primeira Linha -->
				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label>Nome do Plano</label>
							<input
								type="text" 
								class="form-control"
								v-model="plano.name"
                required readonly
							/>
						</div>
					</div>
						
					<div class="col-md-4">
						<div class="form-group">
						<label>Intervalo de Recorrência</label>
						<input
							type="text"
							class="form-control"
							v-model="plano.unit_interval"
              required readonly
						/>
						</div>
					</div>

          <div class="col-md-4">
						<div class="form-group">
							<label>Preço</label>
							<input
							type="text"
							class="form-control"
							v-model="plano.price"
              required readonly
							/>
						</div>
					</div>
				</div>

        <!-- Segunda Linha -->
				<div class="row">
          <div class="col-md-4">
						<div class="form-group">
							<label>Status</label>
							<input
							type="text"
							class="form-control"
							v-model="plano.active"
              required readonly
							/>
						</div>
					</div>

          <div class="col-md-4">
						<div class="form-group">
							<label>Quantidade de Membros</label>
							<input
							type="text"
							class="form-control"
							v-model="plano.qtd_membros"
              required readonly
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Id da Provedora</label>
							<input
							type="text"
							class="form-control"
							v-model="plano.provider_id"
              required readonly
							/>
						</div>
					</div>
				</div>

      <!-- Informações do Titular -->
      <div class="box_general padding_bottom" v-if="titular">
				<div class="header_box version_2">
				<h2>
					<i class="fa fa-info-circle"></i>Informações do Titular
				</h2>
			</div>
				<!-- Primeira Linha -->
				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label>Nome do Titular</label>
							<input
								type="text"
								class="form-control"
								v-model="titular.name"
                required readonly
							/>
						</div>
					</div>
						
					<div class="col-md-4">
						<div class="form-group">
						<label>CPF</label>
						<input
							type="text"
							class="form-control"
							v-model="titular.cpf"
              required readonly
						/>
						</div>
					</div>

          <div class="col-md-4">
						<div class="form-group">
							<label>RG</label>
							<input
							type="text"
							class="form-control"
							v-model="titular.rg"
              required readonly
							/>
						</div>
					</div>
				</div>

        <!-- Segunda Linha -->
				<div class="row">
          <div class="col-md-8">
						<div class="form-group">
							<label>Parentesco</label>
							<input
							type="text"
							class="form-control"
							v-model="titular.parentesco"
              required readonly
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>E-mail do Dependente</label>
							<input
							type="text"
							class="form-control"
							v-model="titular.email"
              required readonly
							/>
						</div>
					</div>
				</div>

        <!-- Terceira Linha -->
				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label>Data de Nascimento</label>
							<input
                type="text"
                class="form-control"
                v-model="titular.birth_date"
                required readonly
                />
						</div>
					</div>

          <div class="col-md-4">
					  <div class="form-group">
							<label>Nome da Mãe</label>
							<input
							type="text"
							class="form-control"
							v-model="titular.nome_mae"
              required readonly
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Nome do Pai</label>
							<input
							type="text"
							class="form-control"
							v-model="titular.nome_pai"
              required readonly
							/>
						</div>
          </div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<p class="pull-right">
							<router-link
                :to="'/adm/titulares/'+titular.id"
                class="btn_1 medium"
              >
              Editar Titular
              </router-link>
						</p>
					</div>
				</div>

			</div>
        
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import { toDate, toTimeStamp } from "@/utils/formater";  

export default {
  mixins: [funcoesGerais],
  data() {
	return {
		id_dependente: this.$route.params.id_dependente,
		lang: {
		days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
	  months: [
		"Jan",
		"Fev",
		"Mar",
		"Abr",
		"Mai",
		"Jun",
		"Jul",
		"Ago",
		"Set",
		"Out",
		"Nov",
		"Dec"
	  ],
	  pickers: [
		"prox 7 dias",
		"prox 30 dias",
		"7 dias anteriores",
		"30 dias anteriores"
	  ],
		placeholder: {
		  date: "Selecione a data",
		  dateRange: "Selecione o intervalo"
		}
	  },
	  dependente: [],
	novoTitular: {
		name: '',
		cpf: '',
		email: '',
		nome_mae: '',
		nome_pai: '',
		subscribers_id: null
    },
    subscribers: [],
    plano: [],
    titular: [],
	isLoading: false,
	showModal: true,
	};
	},
	
  mounted() {
	var self = this;
		var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
		if (user) {
		self.isLoading = true;
		ajax("get", "/dependentes/" + self.id_dependente)
			.then(response => {
				self.isLoading = false;
				self.dependente = response.dependente;
				self.plano = response.plano;
				self.titular = response.titular;
			})
			.catch(error => {
				self.isLoading = false;
				tratamento_requisicao(error, this);
			});
		} else {
			self.$router.replace(self.$route.query.redirect || "/");
		}
	},
  methods: {
		isYoungerThan18(date) {
			let today = new Date();
			let birthDate = new Date(date);
			let age = today.getFullYear() - birthDate.getFullYear();
			let m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			//console.log(age < 18);
			return age < 18;
		},
		edita_dependente() {
			let self = this;
			self.isLoading = true;
			console.log(self.dependente.birth_date);
			//self.dependente.birth_date = toTimeStamp(self.dependente.birth_date);
			if(self.isYoungerThan18(self.dependente.birth_date)) {
				ajax("get", `retorna_titular_por_subscriber/${self.dependente.subscriber_id}`)
				.then(res => {
					console.log('res', res);
					if(res.length == 0){
						console.log('Titular não encontrado');
						alerta("error", "Erro", "Titular não encontrado, crie um titular");
						self.isLoading = false;
						self.$bvModal.show('modalTitular');
						
						return;
					}else{
						console.log('Titular encontrado');
						ajax("put", `dependentes/${self.id_dependente}`, self.dependente)
						.then(res => {
							self.dependente = res;
							self.dependente.birth_date = toDate(self.dependente.birth_date);
							self.isLoading = false;
							alerta("success", "Sucesso", "Dependente alterado com sucesso");
						})
					}
				})
				.catch(e => {
					self.isLoading = false;
					tratamento_requisicao(e);
				})
			}else{
				ajax("put", `dependentes/${self.id_dependente}`, self.dependente)
				.then(res => {
					self.dependente = res;
					self.dependente.birth_date = toDate(self.dependente.birth_date);
					self.isLoading = false;
					alerta("success", "Sucesso", "Dependente alterado com sucesso");
				})
				.catch(e => {
					self.isLoading = false;
					tratamento_requisicao(e);
				})
			}
		},
		criarTitular() {
			let self = this;
			self.isLoading = true;
			self.novoTitular.subscribers_id = self.dependente.subscriber_id;
			//console.log(self.novoTitular);
			ajax("post", `titulares`, self.novoTitular)
			.then(res => {
				self.isLoading = false;
				alerta("success", "Sucesso", "Titular criado com sucesso");
			})
			.catch(e => {
				self.isLoading = false;
				tratamento_requisicao(e);
			})
		}
  }
};
</script>
